// store.js
import { reactive, ref } from 'vue'
import { createGlobalState } from '@vueuse/core'
import { TRANSLATE_LANGUAGES, type IdeaContent, type TLegalType } from '@/types'

export const useGlobalState = createGlobalState(
    () => {
        // state
        const country = ref<string[]>()

        const legal = ref<TLegalType[]>()

        const inputLang = ref<TRANSLATE_LANGUAGES>(TRANSLATE_LANGUAGES.NONE)

        const transLang = ref<TRANSLATE_LANGUAGES>(TRANSLATE_LANGUAGES.NONE)

        const editContent = reactive<IdeaContent>(
            {
                means: '',
                efficacy: '',
            }
        )

        // actions
        function updateCounty(data:string[]) {
            country.value = data
        }
        function updateSelectLegal(data:TLegalType[]) {
            legal.value = data
        }
        function updateInputLang(lang:TRANSLATE_LANGUAGES) {
            inputLang.value = lang
        }

        function updateEditContent(data:IdeaContent) {
            const { means, efficacy } = data
            editContent.means = means;
            editContent.efficacy = efficacy;
        }

        function updateTranslateLang(lang:TRANSLATE_LANGUAGES) {
            transLang.value = lang
        }

        function resetTranslateLang() {
            transLang.value = TRANSLATE_LANGUAGES.NONE
        }

        return {
            country,
            legal,
            inputLang,
            updateCounty,
            updateSelectLegal,
            updateInputLang,
            transLang,
            editContent,
            updateEditContent,
            updateTranslateLang,
            resetTranslateLang,
        }
    }
)
